module.exports = __webpack_public_path__ + "img/20190604161618557.6f96a2a9.png";